var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.painting)?_c('div',{staticClass:"poster"},[_c('vue-canvas-poster',{attrs:{"widthPixels":750,"painting":_vm.painting},on:{"success":_vm.success,"fail":_vm.fail}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }